import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  paper: {
    padding: 32,
    boxShadow: "none",
  },
  fileInput: {
    display: "none",
  },
  fileInputLabel: {
    padding: 8,
    border: "1px solid black",
    display: "inline",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  fileName: {
    display: "inline",
    marginLeft: 8,
  },
}));
